module.exports = __webpack_public_path__ + "mv.6ef58642.svg";